import React from "react";
import '../styles/MultistepProgressBar.css';
//import '../styles/formStyle.module.css';
import { ProgressBar, Step } from "react-step-progress-bar";

const MultiStepProgressBar = ({ page, onPageNumberClick }) => {
  var stepPercentage = 0;
  // if (page === "pageone") {
  //   stepPercentage = 16;
  // } else if (page === "pagetwo") {
  //   stepPercentage = 49.5;
  // } else if (page === "pagethree") {
  //   stepPercentage = 82.5;
  // } else if (page === "pagefour") {
  //   stepPercentage = 100;
  // } else {
  //   stepPercentage = 0;
  // }

  if (onPageNumberClick === 1) {
    stepPercentage = 0;
  } else if (onPageNumberClick === 2) {
    stepPercentage = 34;
  } else if (onPageNumberClick === 3) {
    stepPercentage = 67;
  } else if (onPageNumberClick === 4) {
    stepPercentage = 100;
  } else {
    stepPercentage = 0;
  }

  return (
    <ProgressBar percent={stepPercentage}>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            // onClick={() => onPageNumberClick("1")}
          >
            {index + 1}
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            // onClick={() => onPageNumberClick("2")}
          >
            {index + 1}
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            // onClick={() => onPageNumberClick("3")}
          >
            {index + 1}
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            // onClick={() => onPageNumberClick("4")}
          >
            {index + 1}
          </div>
        )}
      </Step>
    </ProgressBar>
  );
};

export default MultiStepProgressBar;
